import {Entity, EntityJson} from "./base/Entity";

export interface UserJson extends EntityJson {
    username: string;
}

export class User extends Entity {
    username: string;
    static entityType = 'user';

    constructor(json: UserJson) {
        super(json);
        this.username = json.username;
    }

    get entityType(): string {
        return User.entityType;
    }
}